module.exports = __webpack_public_path__ + "img/avatar.13cb99e9.png";